import { Legs } from './legs';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ProductType } from '@/store/modules/product';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';

export const dressingLegs = [
    new Legs(
        `t_n_box.gltf`,
        `t_n_box_light.jpg`,
        new ShaderNBox(),
        0,
        ProductType.DRESSING,
        `t_noga_prosta_debowa_icon.jpg`,
    ),
    new Legs(
        `t_n_okragla.gltf`,
        `t_n_okragla_light.jpg`,
        new ShaderNOkragla(),
        0,
        ProductType.DRESSING,
        `t_noga_metalowa_icon.jpg`,
    ),
    new Legs(
        `t_n_plozy.gltf`,
        `t_n_plozy_light.jpg`,
        new ShaderNPlozy(),
        0,
        ProductType.DRESSING,
        `t_ploza_metalowa_icon.jpg`,
    ),
    new Legs(
        `t_n_st_giety.gltf`,
        `t_n_st_giety_light.jpg`,
        new ShaderNStGiety(),
        0,
        ProductType.DRESSING,
        `t_stelaz_giety_metalowy_icon.jpg`,
    ),
    new Legs(
        `t_n_st_box.gltf`,
        `t_n_st_box_light.jpg`,
        new ShaderNStBox(),
        0,
        ProductType.DRESSING,
        `t_stelaz_skosny_drewniany_icon.jpg`,
    ),
    new Legs(
        `t_n_st_prosta.gltf`,
        `t_n_st_prosta_light.jpg`,
        new ShaderNStProsta(),
        0,
        ProductType.DRESSING,
        `t_stelaz_prosty_metalowy_icon.jpg`,
    ),
    new Legs(
        `t_n_st_przesun.gltf`,
        `t_n_st_przesun_light.jpg`,
        new ShaderNStPrzesun(),
        0,
        ProductType.DRESSING,
        `t_stelaz_skosny_metalowy_icon.jpg`,
    ),
    new Legs(
        `t_n_st_scieta.gltf`,
        `t_n_st_scieta_light.jpg`,
        new ShaderNStScieta(),
        0,
        ProductType.DRESSING,
        `t_stelaz_skosny_debowy_icon.jpg`,
    ),
    new Legs(
        `t_n_st_stozek.gltf`,
        `t_n_st_stozek_light.jpg`,
        new ShaderNStStozek(),
        0,
        ProductType.DRESSING,
        `t_stelaz_skosny_drewniany_stozek_icon.jpg`,
    ),
    new Legs(
        `t_n_stozek.gltf`,
        `t_n_stozek_light.jpg`,
        new ShaderNStozek(),
        0,
        ProductType.DRESSING,
        `t_noga_stozek_drewniana_icon.jpg`,
    ),
    new Legs(
        `t_n_walec.gltf`,
        `t_n_walec_light.jpg`,
        new ShaderNWalec(),
        0,
        ProductType.DRESSING,
        `t_noga_walec_debowa_icon.jpg`,
    ),
];
